import ButtonAccountDropdownInfo from 'features/System/Account/components/ButtonAccountDropdownInfo';
import KTTooltip, { KTTooltipPositions } from 'general/components/OtherKeenComponents/KTTooltip';
import AppColors from 'general/constants/AppColors';
import AppConstants from 'general/constants/AppConstants';
import AppResource from 'general/constants/AppResource';
import AppRoute from 'general/constants/AppRoute';
import LanguageHelper from 'general/helpers/LanguageHelper';
import UIHelper from 'general/helpers/UIHelper';
import useRouter from 'hooks/useRouter';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import './style.scss';
import PushNotificationListView from 'features/System/PushNotification/components/PushNotificationListView';
import ChargeHelper from 'features/Charge/chargeHelper';
import Utils from 'general/utils/Utils';
require('moment/locale/vi');

function KT01Header(props) {
  // ---- params ----
  const { t } = useTranslation();
  const currentLanguage = LanguageHelper.getCurrentLanguage();
  const router = useRouter();
  const { user } = useSelector((state) => state.auth);
  const [currentTime, setCurrentTime] = useState(moment().format('HH:mm:ss'));
  const [isShowNotificationList, setIsShowNotificationList] = useState(false);
  const [unReadNotification, setUnReadNotification] = useState();
  const drawerRef = useRef(null);

  // MARK: --- Hooks ---
  useEffect(() => {
    if (currentLanguage == 'vi') {
      require('moment/locale/vi');
    }
  }, [t, currentLanguage]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(moment().format('hh:mm:ss'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        setIsShowNotificationList(false);
        handleGetNotificationSummary();
      }
    };

    if (isShowNotificationList) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isShowNotificationList, user]);

  useEffect(() => {
    // lấy số thông báo chưa đọc
    handleGetNotificationSummary();
  }, [user])

  const handleGetNotificationSummary = async () => {
    try {
      if (!user?.role || !user?.userId) return;
      const params = { isRead: 0, isSent: 1 };
      if (user?.role === AppConstants.userRole.admin) {
        params.userId = user?.userId;
      }
      const categories = await ChargeHelper.API.Notification.requestGetNotificationSummary(params);
      const unReadNum = Object.values(categories).reduce((total, value) => total + value, 0);
      setUnReadNotification(unReadNum ?? 0);
    } catch (error) {
      console.error("Lỗi khi lấy thống kê thông báo:", error);
    }
  };
  const breadcrumPath = localStorage.getItem('breadcrumPath');
  const parsedBreadcrumbPath = breadcrumPath ? JSON.parse(breadcrumPath) : [];

  return (
    <div
      id="kt_header"
      className="header header-fixed"
      style={{
        backgroundColor: '#FFFFFF',
        borderBottom:
          parsedBreadcrumbPath?.length > 1
            ? `1px solid ${AppColors.gray[200]}`
            : `1px solid ${AppColors.gray[300]}`,
        boxShadow: parsedBreadcrumbPath?.length > 1 ? '' : '0px 7px 8px -3px #0000000D',
        zIndex: '999',
      }}
    >
      <div className="px-4 d-flex align-items-stretch justify-content-between h-100">
        {/* Header menu wrapper */}
        <div id="kt_header_menu_wrapper" className="header-menu-wrapper header-menu-wrapper-left">
          {/* header menu */}
          <div
            id="kt_header_menu"
            className="header-menu header-menu-mobile header-menu-layout-default"
          >
            {/* date & time */}
            <h4 className="d-flex flex-column align-items-start justify-content-center mb-0">
              <small
                className="mt-1"
                style={UIHelper.buildFontStyle('600', '15px', AppColors.primary)}
              >
                {currentTime}
              </small>

              <small
                className="mt-1"
                id="time"
                style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[800])}
              >
                {_.capitalize(moment().format('dddd'))}{' '}
                <span id="date" style={UIHelper.buildFontStyle('400', '14px', AppColors.gray[600])}>
                  • {moment().format('DD/MM/YYYY')}
                </span>
              </small>
            </h4>
          </div>
        </div>

        {/* Top bar */}
        <div className="topbar">
          <div className="topbar-item">
            <ButtonAccountDropdownInfo />
          </div>

          <div className="topbar-item ml-3">
            <KTTooltip
              position={KTTooltipPositions.left}
              offset={[0, 0]}
              text={'Danh sách thông báo'}
            >
              <div
                className="d-flex align-items-center justify-content-center h-40px w-40px p-0 hover-opacity-60 cursor-pointer"
                style={{
                  borderRadius: '10px',
                  backgroundColor: AppColors.gray[200],
                }}
                onClick={() => setIsShowNotificationList((prev) => !prev)}
              >
                <div style={{ position: 'relative', display: 'inline-block' }}>
                  <img
                    src={AppResource.icons.evg.notificationAlertIcon}
                    style={{ width: 20 }}
                    alt="notification"
                  />

                  {Utils.isValid(unReadNotification) && (
                    <span
                      className="position-absolute rounded-pill d-flex align-items-center justify-content-center"
                      style={{
                        ...UIHelper.buildFontStyle("500", "7px", '#FFFFFF'),
                        backgroundColor: '#FF9500',
                        height: '12px',
                        top: '2px',
                        left: '12px',
                        fontSize: '7px',
                        lineHeight: '1',
                        border: `2px solid ${AppColors.gray[200]}`,
                        padding: '0 1px',
                        minWidth: '14px',
                        textAlign: 'center'
                      }}
                    >
                      {unReadNotification > 99 ? '99+' : Utils.formatNumber(unReadNotification)}
                    </span>
                  )}
                </div>
              </div>
            </KTTooltip>

            {isShowNotificationList && (
              <div className="position-fixed top-0 start-0 w-100 h-100" style={{ zIndex: 1050 }}>
                {/* Backdrop */}
                <div
                  className="position-absolute top-0 start-0 w-100 h-100 bg-opacity-50 backdrop-blur-sm"
                  style={{ backgroundColor: 'rgba(var(--bs-dark-rgb), var(--bs-bg-opacity))' }}
                  onClick={() => setIsShowNotificationList(false)}
                />

                {/* Drawer */}
                <div
                  ref={drawerRef}
                  className="position-absolute top-0 end-0 h-100 bg-white shadow-lg d-flex flex-column"
                  style={{
                    width: '326px',
                    transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                    transform: isShowNotificationList ? 'translateX(0)' : 'translateX(100%)',
                    zIndex: 1051,
                  }}
                >
                  {/* Danh sách thông báo */}
                  <div className="flex-grow-1 overflow-auto">
                    <PushNotificationListView
                      setIsShowNotificationList={setIsShowNotificationList}
                      handleRefresh={handleGetNotificationSummary}
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default KT01Header;
